import React from 'react';

// styles
import { PrimaryBtnContainer } from './PrimaryBtn.styles.js';

// assets
import LoadingIcon from '../../loading-icon/LoadingIcon';

const PrimaryBtn = React.memo(function PrimaryBtn({ 
  disabled = false, 
  isDisabled = false,
  title, 
  onClick, 
  type = 'default',
  isLoading = false,
  style,
  width = 'fixed',
  fullWidth = false
}) {
  const isButtonDisabled = disabled || isDisabled || isLoading;
  return (
    <PrimaryBtnContainer 
      type="button"
      className="panel-bg" 
      disabled={isButtonDisabled}
      onClick={onClick}
      $type={type}
      $width={width}
      $fullWidth={fullWidth}
      style={style}
    >
      {isLoading ? <LoadingIcon /> : title}
    </PrimaryBtnContainer>
  );
});

export default PrimaryBtn;